import React from "react";
import { useSelector } from "react-redux";
import { FirmAccountType } from "../graphql/generated";
import { authSelectors } from "../store/auth/selector";

export function FirmRoleRestricted(props: {
  roles: FirmAccountType[];
  children: React.ReactNode;
}) {
  const account = useSelector(authSelectors.account);

  // If no account or no firm account type, don't show children
  if (!account || !account.firmAccountType) {
    return null;
  }

  // Check if the account's firm account type is in the allowed roles
  if (!props.roles.includes(account.firmAccountType)) {
    return null;
  }

  return <>{props.children}</>;
}
